import { render, staticRenderFns } from "./PageManager.vue?vue&type=template&id=1550deb6&"
import script from "./PageManager.vue?vue&type=script&lang=js&"
export * from "./PageManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports